module.exports = __webpack_public_path__ + "img/aaaa.fa80715c.jpg";